/**
 * @module components\loaderMobile
*/
import Vue from 'vue';
import Component from 'vue-class-component';
import singletons from '../singletons';


@Component
export default class LoaderMobile extends Vue {
    static hide() {
      throw new Error('Method not implemented.');
    }
    dialog=false;
    public show(){
            this.dialog=true;
    }
    public hide(){
        this.dialog=false;
    }
    public progress(){
        return this.dialog;
    }
    private mounted() {
        singletons.loaderMobile = this;
      }
}